import { z } from 'zod'
import type { TeamListParams } from '@/api/endpoints/teams'
import { listSearchSchema } from '@/lib/list-search'

/** `/teams` search: the shared list params plus the inactive and without-members filters. */
export const teamsListSearchSchema = listSearchSchema.extend({
  inactive: z.boolean().optional().catch(undefined),
  without_members: z.boolean().optional().catch(undefined),
})

export type TeamsListSearch = z.infer<typeof teamsListSearchSchema>

/**
 * `inactive` in the URL means "include teams without active members".
 * The API treats `inactive=false` as active teams only, so an absent flag is sent as false.
 */
export function toTeamListParams(search: TeamsListSearch): TeamListParams {
  return {
    page: search.page,
    page_size: search.page_size,
    query: search.query,
    server: search.server,
    inactive: search.inactive === true,
    without_members: search.without_members === true ? true : undefined,
  }
}
